import { withStyles } from '@material-ui/core';
import { inject } from 'mobx-react';
import { Grid, List, CircularProgress } from "@material-ui/core";
import { observer } from 'mobx-react-lite';
import classNames from "classnames";
import React from 'react';
import ItemList from "../../../../../components/Modal/ItemList";
import Scroll from "../../../../../components/InfiniteScroll/Scroll";

const Sugestoes = observer(({ classes, TGOStore }) => {
    const loadMoreSugestoes = async () => {
        if (TGOStore.sugestoesLoading) {
          return;
        }
    
        TGOStore.sugestoesPagAtual =
          TGOStore.sugestoes.length > 0 ? TGOStore.sugestoesPagAtual + 1 : 0;
    
        await TGOStore.findAllGuiaServicoTussViewQuantidadeUso({
          pageableDTO: {
            pageSize: 10,
            pageNumber: TGOStore.sugestoesPagAtual,
            sortDir: "DESC",
            sortField: "quantidadeUso",
          },
        });
      };
    
  const selectSugestao = async (item) => {
    const { objView } = TGOStore;

    if (TGOStore.disabledListaLateral) {
      return;
    }     
    objView.descricao = {
      value: item.tussView.descricao,
      label: item.tussView.descricao,
    };
    objView.tabela = {
      value: item.tussView.tabela,
      label: item.tussView.tabela,
    };
    objView.codigoTermo = {
      localOdontograma: item.localOdontograma,
      value: item.tussView.codigoTermo,
      label: item.tussView.codigoTermo,
    };
    objView.face = {
      value: item.face,
      label: item.face,
    }
    objView.localTipoId = item?.localTipoId
  };

    return(
        <Scroll
          loadMore={loadMoreSugestoes}
          initialLoad={false}
          hasMore={!TGOStore.sugestoesLast}
          pageStart={0}
          className={classes.scrollContainerSugestoes}
        >
          <List>
            {TGOStore.sugestoes.map((item, i) => (
              <Grid
                id={`prt-gtg-div-sug-${i}`}
                container
                key={i}
                className={classNames(
                  classes.cardSugestao,
                  TGOStore.disabledListaLateral && classes.cursorDefault
                )}
                onClick={() => selectSugestao(item)}
              >
                <div
                  className={
                    TGOStore.disabledListaLateral && classes.cardSugestaoDisabled
                  }
                >
                  <ItemList
                    size={12}
                    field={"Descrição:"}
                    value={item.tussView.descricao}
                    className={classes.itemList}
                  />
                  <div className={classes.codigoTabela}>
                    <ItemList
                      size={6}
                      field={"Código:"}
                      value={item.tussView.codigoTermo}
                      className={classes.itemList}
                    />
                    <ItemList
                      size={6}
                      field={"Tabela:"}
                      value={item.tussView.tabela}
                      className={classes.itemList}
                    />
                  </div>
                </div>
              </Grid>
            ))}
            {TGOStore.sugestoesLoading && (
              <div className={classes.notFoundContainer}>
                <CircularProgress style={{ color: "#fff" }} />
              </div>
            )}
          </List>
        </Scroll>
    )
});

const styles = {
  scrollContainerSugestoes: {
    height: 520,
  },
  cardSugestao: {
    margin: "10px 30px",
    background: "#fff",
    alignSelf: "center",
    padding: 10,
    width: "80%",
    borderRadius: 10,
    cursor: "pointer",
  },
  cursorDefault: {
    cursor: 'default',
  },
  cardSugestaoDisabled: {
    opacity: 0.5,
  },
  itemList: {
    fontSize: "12px !important",
    fontFamily: "Poppins !important",
  },
  codigoTabela: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
  },
  notFoundContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "80%",
    margin: 20,
  },
}

const SugestoesWithStyles = withStyles(styles)(Sugestoes);
export default inject("TGOStore")(SugestoesWithStyles)